//generate react component for ContentCard with TypeScript and scss

import './CoralBadge.scss'

import React from 'react'

type CoralBadgeProps = {
  backgroundColor?: string
  text: string
}
export const CoralBadge: React.FC<CoralBadgeProps> = (props) => {
  return <div className={`coral-badge m--color-${props.backgroundColor}`}>{props.text}</div>
}
